import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

const phoneCharacters = /^\+?[\d\s().-]*$/;
export function formatEnquiryPhone(value) {
  // Never silently remove invalid letters or truncate an overlong number.
  return phoneCharacters.test(value) ? new AsYouType('ZW').input(value) : value;
}
export function validEnquiryPhone(value) {
  if (!phoneCharacters.test(value)) return null;
  const phone = parsePhoneNumberFromString(value, { defaultCountry: 'ZW', extract: false });
  return phone?.isValid() && !phone.ext ? phone : null;
}
export function contactFieldError(key, raw, required = false) {
  const value = (raw || '').trim();
  if (!value) return required ? key === 'name' ? 'Enter a name.' : key === 'phoneNumber' ? 'Enter a phone number.' : key === 'email' ? 'Enter an email address.' : 'Enter a social handle or profile link.' : '';
  if (key === 'name' && value.length > 200) return 'Use 200 characters or fewer.';
  if (key === 'phoneNumber' && /^0/.test(value) && value.replace(/\D/g,'').length > 10) return 'Too many digits. A Zimbabwe mobile number has 10 digits, e.g. 077 123 4567.';
  if (key === 'phoneNumber' && (value.length > 60 || !validEnquiryPhone(value))) return 'Enter a valid number, e.g. 077 123 4567 or +263 77 123 4567.';
  if (key === 'email' && (value.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))) return 'Enter a valid email address, e.g. name@example.com.';
  if (key === 'socialHandle' && value.length > 300) return 'Use 300 characters or fewer.';
  return '';
}
export function enquiryContactErrors(form, method) {
  const errors = {};
  for (const key of ['name', method, ...['phoneNumber','email','socialHandle'].filter(key=>key!==method)]) {
    const message = contactFieldError(key, form[key], key === 'name' || key === method);
    if (message) errors[key] = message;
  }
  return errors;
}
